/* eslint-disable import/prefer-default-export, dot-notation */
import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { ApplicationContext } from '@antegma/accallio-cloud-react-components/lib/app/context'
import { ContentItem } from '@antegma/accallio-cloud-hootsuite-application-api-javacript-sdk'
import { TDefaultSagas } from '@antegma/accallio-cloud-react-components/lib/hootsuite/common/redux/interface'
import contentSourceApi from '~/services/ContentSource'
import tokenApi from '~/services/Token'

/**
 * Custom hook to handle uploading content to Hootsuite Composer
 * Supports both Image and Video content types
 */
export const useUploadToComposer = (): { uploadToComposer: (contentItem: ContentItem) => Promise<void> } => {
  const ctx = useContext(ApplicationContext)
  const oidc = useSelector((state: TDefaultSagas) => state.oidc)

  let hootsuiteUserId: string
  if (ctx.extraQueryParams !== undefined) {
    hootsuiteUserId = ctx.extraQueryParams.hootsuiteUserId
  }

  const options = {
    headers: {
      Authorization: `Bearer ${oidc.user?.access_token}`,
    },
  }

  const uploadToComposer = (contentItem: ContentItem): void => {
    if (!contentItem || !contentItem.id) {
      console.error('Invalid content item')
      return
    }

    const contentItemId = contentItem.id

    if (contentItem.mediaType === 'Video') {
      uploadVideoToComposer(contentItemId)
    } else if (contentItem.mediaType === 'Image') {
      uploadImageToComposer(contentItem)
    }
  }

  const uploadVideoToComposer = (contentItemId: string): void => {
    contentSourceApi.uploadContentItemToHootsuite(contentItemId, options).then((response) => {
      const hootsuiteMediaId = response.data
      const dateTime = Date.now()
      const timestamp = Math.floor(dateTime / 1000)
      const userId = hootsuiteUserId
      const input = `${userId}${timestamp}${hootsuiteMediaId}`

      console.log(`hootsuite user id for attach to media: ${hootsuiteUserId}`)

      tokenApi.generateToken(input, options).then((tokenResponse) => {
        const token = tokenResponse.data

        window['hsp']['attachMediaV2']({
          mediaId: hootsuiteMediaId,
          timestamp,
          token,
        })
      })
    })
  }

  const uploadImageToComposer = (contentItem: ContentItem): void => {
    const url = contentItem.urls?.original
    const dateTime = Date.now()
    const timestamp = Math.floor(dateTime / 1000)
    const input = `${hootsuiteUserId}${timestamp}${url}`

    console.log(`hootsuite user id for attach file to message: ${hootsuiteUserId}`)

    tokenApi.generateToken(input, options).then((tokenResponse) => {
      const token = tokenResponse.data
      const fileNameParts = contentItem.name?.split('.')
      let extension = ''
      if (fileNameParts !== undefined) {
        extension = fileNameParts[fileNameParts.length - 1]
      }

      window['hsp']['attachFileToMessageV2']({
        url,
        name: contentItem.name,
        extension,
        timestamp,
        token,
      })
    })
  }

  return { uploadToComposer }
}
